import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const addStaffApi = (data) =>
  axios.post(`${API_BASE_URL}/api/add-staff`, data);

export const updateStaffApi = (data) =>
  axios.post(`${API_BASE_URL}/api/update-staff`, data);

export const updateUserStatusApi = (userId, status) =>
  axios.post(`${API_BASE_URL}/api/update-user-status`, { userId, status });

export const updateUserAttendanceApi = (userId, status) =>
  axios.post(`${API_BASE_URL}/api/update-user-attendance`, { userId, status });
export const getUserByID = (userId) =>
  axios.get(`${API_BASE_URL}/api/user/${userId}`);
export const getStaffListApi = (params) =>
  axios.get(`${API_BASE_URL}/api/staff-list`, { params });
